import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../../css/login.css";
import {Navbar} from "../userfolder/Navbar";
import { FaUser, FaLock } from "react-icons/fa";

const Login = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("🔍 Sending Login Request:", formData);
    try {
      const response = await axios.post("/agent/login", formData);
      console.log("Login successful, response:", response.data);
  
      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
  
        // Decode token to extract agent_id and agent_name
        const tokenPayload = JSON.parse(atob(response.data.token.split('.')[1]));
        localStorage.setItem("agent_id", tokenPayload.agent_id); // Store agent ID
        localStorage.setItem("agent_name", tokenPayload.name); // Store agent Name
  
        console.log("Token & Agent Info stored, navigating to dashboard...");
        navigate("/listings"); // Redirect to listings page
      } else {
        alert("Login failed, no token received.");
      }
    } catch (error) {
      console.error("Login error:", error.response?.data || error);
      alert(error.response?.data?.message || "Login error");
    }
  };
   

  return (
    <div className="login-page">
      <Navbar />
      <div className="height">
            <div className="login-container">
      <h2 className="login-title">Agent Login</h2>
      <form onSubmit={handleSubmit} className="login-form">
        <div className="input-container">
          <FaUser className="input-icon" />
        <input type="email" name="email" placeholder="Email" onChange={handleChange} required className="login-input" /></div>
        <div className="input-container">
        <FaLock className="input-icon" />
        <input type="password" name="password" placeholder="Password" onChange={handleChange} required className="login-input" /></div>
        <button type="submit" className="login-button">Login</button>
      </form>
      </div>

    </div>
    </div>
  );
};

export default Login;
